<template>
  <div>
    <v-app-bar
      color="white"
      height="64"
      style="z-index: 100; box-shadow: 0px 1px 4px rgba(117, 125, 132, 0.2)"
    >
      <div class="d-flex align-center">
        <a :href="url" target="_blank" class="d-flex align-center">
          <img :src="logo" style="height: 32px; width: 108px" />
        </a>
        <!-- <v-btn text class="ml-3 text-body-1" @click="GoRouter('Home')">{{
          index
        }}</v-btn> -->
      </div>
      <v-spacer />
      <!-- #region 各式服務菜單 -->
      <v-menu offset-y nudge-bottom="12" :nudge-width="412" max-width="412">
        <template v-slot:activator="{ attrs, on }">
          <v-btn fab v-bind="attrs" v-on="on" text small>
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-card class="pa-4" outlined>
          <div class="text-body-2 font-weight-black mb-2">小芋頭服務</div>
          <v-row class="d-flex">
            <v-col cols="4" v-for="x in taroService" :key="x.name">
              <div
                class="justify-center text-center service-block"
                @click="GoUrl(x.action)"
              >
                <div class="d-flex justify-center">
                  <v-img
                    :src="x.icon"
                    contain
                    max-height="38"
                    max-width="38"
                    class="rounded-lg"
                  ></v-img>
                </div>
                <div class="mt-1 text-body-2">{{ x.name }}</div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <div class="d-flex justify-space-around">
            <v-btn @click="GoRouter('Share')" text>
              <v-icon left>mdi-share-variant</v-icon>分享小芋頭平台
            </v-btn>
            <v-btn @click="Share('/ads')" text>
              <v-icon left>mdi-share-variant</v-icon>分享小芋頭廣告
            </v-btn>
          </div>
        </v-card>
      </v-menu>
      <!-- #endregion -->

      <!-- #region 右邊頭像菜單 -->
      <!-- <template v-if="$vuetify.breakpoint.width > 599.89">
        <template v-if="$store.state.signinStatus">
          <v-menu
            v-model="menu"
            offset-y
            allow-overflow
            nudge-left="240"
            class="white"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                color="grey lighten-4"
                size="36"
                v-bind="attrs"
                v-on="on"
              >
                <v-img
                  :src="
                    $store.state.userPhoto !== ''
                      ? $store.state.userPhoto
                      : userInfo.photo
                  "
                  cover
                ></v-img>
              </v-avatar>
            </template>
            <QuickMenu :mode="'menu'" />
          </v-menu>
        </template>
        <template v-else>
          <v-btn color="primary" large @click="GoRouter('SignIn')">{{
            btnText
          }}</v-btn>
        </template>
      </template> -->

      <!-- #endregion -->

      <!--  #region 提示條 -->
      <v-snackbar
        top
        class="position: sticky; position: -webkit-sticky; bottom: 0;"
        v-model="snackbar.show"
        :timeout="1500"
      >
        {{ snackbar.content }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
          >
            {{ snackbar.close }}
          </v-btn>
        </template>
      </v-snackbar>
      <!-- #endregion -->
    </v-app-bar>
  </div>
</template>

<script>
// import QuickMenu from "./QuickMenu";

export default {
  components: {
    // QuickMenu,
  },
  name: "Header",
  data() {
    return {
      snackbar: {
        show: false,
        content: "",
        close: "關閉",
      },
      logo: require("@/assets/tarologo.png"),
      title: "小芋頭",
      index: "首頁",
      url: process.env.VUE_APP_MAIN_BASE_URL,
      menu: false,
      userInfo: {
        photo: require("@/assets/image/common/user-img.svg"),
      },
      btnText: "註冊/登入",
      taroService: [
        {
          name: "小芋頭平台",
          icon: require("@/assets/image/serivceIcon/platform_icon.svg"),
          action: process.env.VUE_APP_MAIN_BASE_URL,
        },
        {
          name: "小芋頭社群",
          icon: require("@/assets/image/serivceIcon/sms_icon.svg"),
          action: process.env.VUE_APP_MAIN_SMS_BASE_URL,
        },
        {
          name: "小芋頭廣告",
          icon: require("@/assets/image/serivceIcon/ad_icon.svg"),
          action: process.env.VUE_APP_MAIN_BASE_URL + "/ads",
        },
        {
          name: "金豐勞動法務健檢網",
          icon: require("@/assets/image/serivceIcon/llh_icon.svg"),
          action: "https://labor.kf-9595.com/",
        },
        {
          name: "金豐薪資雲端網",
          icon: require("@/assets/image/serivceIcon/hr1_icon.svg"),
          action: "https://hr.king-fong.com/",
        },
        {
          name: "免費AI勞動法務諮詢",
          icon: require("@/assets/image/ai/金豐ai公版icon.svg"),
          action: process.env.VUE_APP_MAIN_AICHAT_BASE_URL,
        },
      ],
    };
  },
  mounted() {
    // this.userInfo.photo = "https://pics.ettoday.net/images/2471/2471912.jpg";
  },
  methods: {
    GoRouter(url) {
      if (url === "SignIn") {
        this.$router.push({ name: url, query: { status: "SignIn" } });
        return;
      }
      this.$router.push({ name: url });
    },
    GoUrl(url) {
      let newWindow = window.open();
      newWindow.location.href = url;
    },
    Share(url) {
      let preWord;
      let href;
      href = process.env.VUE_APP_MAIN_BASE_URL;

      if (url) {
        href += url;
      }

      if (url === "/ads") {
        preWord = `邀請您建立【小芋頭免費社群輪播廣告】網站 `;
      }

      this.$copyText(preWord + href)
        .then(() => {
          this.snackbar.show = true;
          this.snackbar.content = "連結已複製。";
        })
        .catch(() => {
          //console.log(err);
          this.snackbar.show = true;
          this.snackbar.content = "複製失敗，請手動複製。";
        });
      // App分享
      if (navigator.share && this.$store.state.userDevice.mobile) {
        navigator
          .share({
            title: "小芋頭廣告",
            text: preWord,
            url: href,
          })
          .then(() => {})
          .catch(() => {
            this.sheet = true;
          });
      }
    },
  },
};
</script>

<style>
.footer-h {
  height: 168px;
}

.service-block {
  padding: 8px;
  border-radius: 8px 0px 0px 0px;
  cursor: pointer;
}

.service-block:hover {
  background: var(--product-color-taro-gary-bg, #fafafa);
}
</style>
